export const APP_ENTRY_URL = 'https://wikigold.onelink.me/OtaH/GoldDigger';
export const EXPERIENCE_RECORD_NOTE = '活动体验记录';
export const CALENDAR_VISIBLE_FIELDS = Object.freeze(['页面标题', '年月', '当天日期区域', '当天Save记录']);

export interface GuideStep {
  originalImage: number;
  asset: string;
  titleKey: string;
  instructionKey: string;
}

export const GUIDE_STEPS: readonly GuideStep[] = Object.freeze([
  {
    originalImage: 1,
    asset: '../../public/assets/app-guide/01-add-gold.jpg',
    titleKey: 'guide.step1.title',
    instructionKey: 'guide.step1.body',
  },
  {
    originalImage: 2,
    asset: '../../public/assets/app-guide/02-type-purity.jpg',
    titleKey: 'guide.step2.title',
    instructionKey: 'guide.step2.body',
  },
  {
    originalImage: 3,
    asset: '../../public/assets/app-guide/03-amount-weight.jpg',
    titleKey: 'guide.step3.title',
    instructionKey: 'guide.step3.body',
  },
  {
    originalImage: 4,
    asset: '../../public/assets/app-guide/04-purchase-info.jpg',
    titleKey: 'guide.step4.title',
    instructionKey: 'guide.step4.body',
  },
  {
    originalImage: 5,
    asset: '../../public/assets/app-guide/05-note-save.jpg',
    titleKey: 'guide.step5.title',
    instructionKey: 'guide.step5.body',
  },
  {
    originalImage: 6,
    asset: '../../public/assets/app-guide/06-saved-record.jpg',
    titleKey: 'guide.step6.title',
    instructionKey: 'guide.step6.body',
  },
  {
    originalImage: 7,
    asset: '../../public/assets/app-guide/07-me-calendar.png',
    titleKey: 'guide.step7.title',
    instructionKey: 'guide.step7.body',
  },
  {
    originalImage: 8,
    asset: '../../public/assets/app-guide/08-gold-calendar.jpg',
    titleKey: 'guide.step8.title',
    instructionKey: 'guide.step8.body',
  },
].map(step => Object.freeze(step)));

export const CALENDAR_GUIDE_STEP = GUIDE_STEPS[7]!;
